import { connect } from 'react-redux'
import { mapProps, lifecycle, compose, renderNothing, branch } from 'recompose'
import { getItem } from '../selectors'
import { findEntity } from '../actions'
import { toggleCurrentBids } from '../layout/'
//import { getCurrentBid } from './index'
import CardHorizontal from '../../ui/cards/card-horizontal'
import numeral from '../../core/numeral'
import { getBidTagData } from '../../ui/tags/utils'

function makeMapStateToProps(state, ownProps) {
  const { itemId } = ownProps
  const getItemSelector = getItem(itemId)
  return function mapStateToProps(state) {
    const item = getItemSelector(state)
    const bid = item ? item.currentBid : null

    return {
      bid,
      itemId, //for fetching
      item
    }
  }
}

const mapDispatchToProps = { onClick: toggleCurrentBids, findEntity }

const mapToCardProps = mapProps(props => {
  const { item, bidState, onClick } = props
  const {
    text: stateTag,
    colorState: colorStateTag,
    iconName: iconStateTag
  } = getBidTagData(bidState)
  return {
    showStateTag: true,
    stateTag,
    colorStateTag,
    iconStateTag,
    caption: numeral(item.currentBidAmount).format('$0,0.00'),
    bidState,
    heading: item ? item.title : 'Loading...',
    smallText: item && item.auction ? item.auction.title : '',
    imageUrl: item && item.media && item.media.length ? item.media[0] : '',
    linkUrl: item ? '/items/' + item.id : '',
    onClick
  }
})

const fetchDataIfNeeded = lifecycle({
  componentWillMount() {
    const { item, itemId, findEntity } = this.props
    if (!item || !item.currentBid) {
      //no entity found, fetch it
      findEntity('items', itemId)
    }
  }
})

const renderNothingIfNoData = branch(props => !props.item, renderNothing)

export const decorate = compose(
  connect(makeMapStateToProps, mapDispatchToProps),
  fetchDataIfNeeded,
  renderNothingIfNoData,
  mapToCardProps
)

export default decorate(CardHorizontal)



// WEBPACK FOOTER //
// ./src/services/bid/current-bid-card.js